import { AxiosError, HttpStatusCode } from 'axios'

export const isForbiddenError = (error: Error | AxiosError | null): boolean => {
  if (error === null) {
    return false
  }
  const axiosError = error as AxiosError
  return axiosError?.response?.status === HttpStatusCode.Forbidden
}
